import { InjectionToken } from '@angular/core';

export interface FactoryAttestationConfig {
  apiUrl: string;
}

export const FACTORY_ATTESTATION_CONFIG = new InjectionToken<FactoryAttestationConfig>('FactoryAttestationConfig');
